module.exports = {
  "$id": "deregistration",
  "type": "object",
  "title": "校验密码",
  "properties": {
    "checkPassword": {
      "title": "密码",
      "type": "string",
      "format": "newPassword"
    }
  },
  "required": [
    "checkPassword",
  ],
  "errorMessage": {
    "checkPassword": {
      "message": "请输入密码，密码要求8-15位，大小写字母、数字、特殊符号4种中的至少3种",
      "required": "密码不能为空"
    }
  }
}
